import React from "react";
import { toast } from "react-toastify";
import { validMomentTimezones } from "./timezones";
import moment from "moment";

export const updateTextInputStyle = (touched, errors) => {
  const style = "px-3 py-3 placeholder-gray-400 rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150";

  return touched ? errors ? `${style} text-gray-300 bg-red-400` : `${style} text-gray-900 bg-green-200` : `${style} text-gray-700 bg-white`;
};

export const formPostStyle = (touched, errors) => {
  const style = "px-3 py-3 placeholder-gray-400 border border-solid border-gray-400 bg-red-400 rounded text-sm focus:outline-none w-full ease-linear transition-all duration-150";

  return touched ? errors ? `${style} text-gray-300` : `${style} text-gray-900` : `${style} text-gray-700`;
};

export const hyphenatedStr = (str) => {
  var splitted = str.split(" ");
  var joined = splitted.join("-").toLowerCase();
  return joined;
};

export const getDateStr = (date) => {
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var year = date.getFullYear();
  var dj = year + "-" + month + "-" + day;
  return dj;
};

export const toastNotification = (status, message) => {
  // //console.log(status);
  switch (status) {
    case "success":
      toast.success(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      break;
    case "error":
      toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      break;
    default:
      toast.warn(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      break;
  }
};

export const favToastNotification = (message) => {
  toast.success(message, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
  });
};

export const favWarnToast = (message) => {
  toast.success(message, {
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
  });
};

export const getUTCString = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth();
  month = month + 1;
  month = month.toString();
  month = month.length === 1 ? "0" + month : month;
  var dat = date.getDate();
  dat = dat.toString();
  dat = dat.length === 1 ? "0" + dat : dat;
  var hr = date.getHours();
  hr = hr.toString();
  hr = hr.length === 1 ? "0" + hr : hr;
  var min = date.getMinutes();
  min = min.toString();
  min = min.length === 1 ? "0" + min : min;
  var sec = date.getSeconds();
  sec = sec.toString();
  sec = sec.length === 1 ? "0" + sec : sec;
  var ms = date.getMilliseconds();
  ms = ms.toString();
  ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;

  var utcdate =
    year +
    "-" +
    month +
    "-" +
    dat +
    "T" +
    hr +
    ":" +
    min +
    ":" +
    sec +
    "." +
    ms +
    "Z";

  return utcdate;
};

export const getTZOptions = () => {
  const defaultOption = (
    <option key="default" value="Select">
      Select Timezone
    </option>
  );
  const options = validMomentTimezones.map((item, index) => {
    return (
      <option key={index} value={item}>
        {item}
      </option>
    );
  });
  const selectOptions = [defaultOption, ...options];
  return selectOptions;
};

export const getMonthName = (month_no) => {
  switch (month_no) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Aug";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";
    default:
      return month_no;
  }
};

export const getTZFormatDateStr = (d, timeZone) => {
  var b = moment(d);
  return b.tz(timeZone).format("MMMM DD, HH:mm");
};

export const getFormatFrmDateStr = (d) => {
  var dat = d.slice(0, 10);
  var tim = d.slice(11, 19);
  var datArr = dat.split("-");
  var timArr = tim.split(":");
  var monthName = getMonthName(parseInt(datArr[1]));
  var datStr = monthName + " " + datArr[2] + ", " + timArr[0] + ":" + timArr[1];
  return datStr;
};

export const getZoneAbbr = (d, timeZone) => {
  var b = moment(d);
  return b.tz(timeZone).zoneAbbr();
};

export const getecoSystemvalues = (values, ecoSystemList) => {
  var valArr = values.split(",");
  //var str = "";
  //console.log(valArr);
  var valNameArr = valArr.map((element) => {
    var elm = ecoSystemList.filter((item) => item.id === element);
    if (elm.length > 0) {
      return elm[0].name;
    } else return "";
  });
  return valNameArr.join(", ");
};

export const gettdClass = (tabSelected) => {
  const tableHeaderClass =
    "px-3 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-no-wrap font-semibold text-left text-gray-300 border-blue-900";

  if (
    tabSelected === null ||
    tabSelected === "whitelist" ||
    tabSelected === "closed" ||
    tabSelected === "ongoing" ||
    tabSelected === "radar"
  ) {
    //console.log(tabSelected);
    return "px-3 align-middle border border-solid py-3 text-xs border-l-0 text-left text-gray-300 uppercase font-semibold border-blue-900";
  } else return tableHeaderClass;
};


export const getRandomString = (length) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let randomStr = "";
  for (let i = 0; i < length; i++) {
    const randomNum = Math.floor(Math.random() * characters.length);
    randomStr += characters[randomNum];
  }
  return randomStr;
}

export const stripTrailingSlash = (str) => {
  return str.endsWith('/') ?
    str.slice(0, -1) :
    str;
};

export const formattedDate = (d = new Date()) => {
  return [d.getFullYear(), d.getMonth() + 1, d.getDate()]
    .map(n => n < 10 ? `0${n}` : `${n}`).join('-').toString();
}

export const formattedDateTime = (d = new Date()) => {
  const formatDate = [d.getFullYear(), d.getMonth() + 1, d.getDate()]
    .map(n => n < 10 ? `0${n}` : `${n}`).join('-').toString();
  const formatTime = [d.getHours(), d.getMinutes(), d.getSeconds()]
    .map(n => n < 10 ? `0${n}` : `${n}`).join(':').toString();
  return `${formatDate} ${formatTime}`;
}